export var isVttCue=function(t){return"getCueAsHTML"in t};